import { initEasasJs } from "core/DynamicComponentLoader";
import * as Sentry from "@sentry/react";
import "./style/style";
import "react-tooltip/dist/react-tooltip.css";
import { getBuildId, isProd } from "utils/utils";
import "utils/legacy";
import "utils/translate-mode";

export default async function startEasasJs() {
  Sentry.init({
    dsn: "https://477942852d6c45409f616dae95b09608@o4508766765580288.ingest.de.sentry.io/4508766780915792",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      /^https:\/\/(app-\d+|staging\.app-01)\.dween\.com\/EASAS/,
      /^https:\/\/app-\d+\.dween\.com\/EASAS/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  console.log("EASAS-JS main bundle entry point...");
  console.log(`EASAS-JS is running in ${isProd() ? "production" : "development"} mode`);
  console.log(`Auto CD Build ID: ${getBuildId()}`);

  await initEasasJs();
}
